<template>
  <v-dialog
      v-model="addVehicleTypeDialog"
      width="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          color="primary"
          v-bind="attrs"
          v-on="on"
          class="mr-4"
      >
        New Vehicle Type
      </v-btn>
    </template>

    <v-card>
      <v-container>
        <v-row>
          <v-col>
            <h3 class="primary--text">
              Please select a vehicle type
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select
                v-model="selectedVehicleTypes"
                :items="availableVehicleTypes"
                item-text="name"
                item-value="key"
                label="Select vehicle type"
                return-object
                single-line
                multiple
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row justify="end" class="pr-4">
          <v-btn color="primary" v-on:click="addVehicleType">Save</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getFirestore, arrayRemove, arrayUnion, updateDoc, doc } from 'firebase/firestore';
const db = getFirestore();

export default {
  name: "AddVehicleType",
  props: {
    serviceAreaId: String,
    wasteType: Object,
    getVehicleTypes: Function,
    assignedVehicleTypes: Array
  },
  data() {
    return {
      isDataLoaded: false,
      addVehicleTypeDialog: false,
      selectedVehicleTypes: [],
      availableVehicleTypes: []
    }
  },
  methods: {
    addVehicleType() {
      const docRef = doc(db, 'service-provider-areas', this.serviceAreaId)
      updateDoc(docRef, {
        wasteTypes: arrayRemove(this.wasteType)
      })
      .then(() => {
        const updatedVehicles = this.wasteType.vehicles
        ? this.selectedVehicleTypes.concat(this.wasteType.vehicles)
        : this.selectedVehicleTypes;

        const docRef = doc(db, 'service-provider-areas', this.serviceAreaId)
        updateDoc(docRef, {
          wasteTypes: arrayUnion({
            ...this.wasteType,
            vehicles: updatedVehicles
          })
        })
        .then(() => {
          this.$router.go();
        })
        .catch((error) => {
          alert(`Failed to update service area: ${error.message}`);
        });
      })
    },
    isVehicleTypeEqual(one, two) {
      return one.key === two.key;
    },
    findExcludedElements(fullset, subset, compareElement) {
      let excluded = [];
      fullset.forEach((element) => {
        const maybeElement = subset.find((el) => {
          return compareElement(el, element)
        });
        if (!maybeElement) {
          excluded.push(element);
        }
      });

      return excluded;
    }
  },
  async updated() {
    if(!this.isDataLoaded) {
      const vehicleTypes = await this.getVehicleTypes();

      this.availableVehicleTypes = this.findExcludedElements(
          vehicleTypes,
          this.assignedVehicleTypes ?? [],
          this.isVehicleTypeEqual
      );

      this.isDataLoaded = true;
    }
  },
  async mounted() {

  }
}
</script>

<style scoped>

</style>